import { IPrice } from './../interfaces/cart-details.interface';
import { AfterViewInit, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { ExternalInterfacesEnum, ExternalInterfacesService } from '../external-interfaces/external-interfaces.service';
import { CommonInfoService } from '../cart-process/common-info.service';
import { IOrderSummary } from '../interfaces/order-summary.interface';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import { ICartDetails } from '../interfaces/cart-details.interface';
import { CartDetailsSourceIdsEnum } from '../models/cartDetails/data-source-ids.enum';
import { IConfig } from '../interfaces/config.interface';
import SlotService from '../cart-process/slot.service';
import { DataLayerService } from '../customer-actions/data-layer.service';
import { FormStateChangeService } from '../customer-form/form-state/form-state-change.service';

declare const window: any;
declare const P4: any;

@Component({
  selector: 'page-summary-view-component',
  templateUrl: './page-summary-view.component.html',
})
export class PageSummaryViewComponent implements OnInit, AfterViewInit {

  public linkNext: string;
  public cartId: string;
  public orderData: IOrderSummary.Root;
  public deliveryCost: IPrice;
  private cartDetails: ICartDetails;

  constructor(
    @Inject('Endpoint') private endpoint: any,
    public commonInfo: CommonInfoService,
    private elementRef: ElementRef,
    private externalInterfacesService: ExternalInterfacesService,
    private notificationProviderService: NotificationProviderService,
    private formStateChangeService: FormStateChangeService,
    private slotService: SlotService,
    private dataLayerService: DataLayerService
  ) {
    this.externalInterfacesService.getData(ExternalInterfacesEnum.CART_DETAILS);

    const nativeElement = this.elementRef.nativeElement;

    this.linkNext = nativeElement.getAttribute('link-next');

    window.reloadCartDetailsInnerNg2 = this.externalInterfacesService.updateCartDetails.bind(this.externalInterfacesService, CartDetailsSourceIdsEnum.RELOAD);
  }

  ngOnInit(): void {
    this.notificationProviderService.subscribe(
      NotificationProviderTypeEnum.CONFIG,
      (config: IConfig) => {
        if (config) {
          this.cartId = config.cartId;
        }
      });

    this.getOrderSummary();

    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails && cartDetails._sourceId === CartDetailsSourceIdsEnum.RELOAD) {
        this.getOrderSummary();
      }

      this.cartDetails = cartDetails;
    });
  }

  ngAfterViewInit() {
    P4.modules.stickyElements.init();
  }

  private getSessionStorageData(): void {
    let formStateData = JSON.parse(sessionStorage.getItem('formStateData'));
    const deliveryItem = this.formStateChangeService.StateInputFields.DELIVERY_COST;

    if (formStateData && typeof formStateData === 'string') {
      formStateData = JSON.parse(formStateData);
    }

    this.deliveryCost = formStateData[deliveryItem];
  }

  private getOrderSummary(): void {
    this.getSessionStorageData();

    if (!this.cartId) return;

    this.endpoint('checkout.summary', {cartId: this.cartId})
      .run()
      .then((response: IOrderSummary.Root) => {
        this.orderData = response;
        Object.assign(response, {deliveryCost: this.deliveryCost});
        this.dataLayerService.cartViewCheckout(this.cartDetails.summaryPrices, this.slotService.getSlots(), response);
      })
      .catch((error: any) => {});
  }
}
